'use client';
import dynamic from 'next/dynamic';

import { LicenseeTypeEnums } from '@nf/types/site';

import { siteService } from '@/services/site.service';
import { useIsOddsListPage } from '@/domains/navigation/hooks/use-is-odds-list-page';

import { LoginModalLoader } from './login-modal';
import { MessageModalLoader } from './message-modal';
import { SportEditModalLoader } from '../profile/profile-panel/components/sport-edit-modal';
import { NickNameModalLoader } from './nickname-modal';
import { ExchangeModalLoader } from '../exchange-modal';
import { FeatureUpdatedModalLoader } from './feature-updated-modal';

const AthenaModals = dynamic(
	() => import('./components/athena-modals').then(m => m.AthenaModals),
	{ ssr: false }
);

const RevisionTutorialModalLoader = dynamic(
	() => import('./revision-tutorial-modal').then(m => m.RevisionTutorialModalLoader),
	{ ssr: false }
);

const VSTournamentModalLoader = dynamic(
	() => import('./vs-tournament-modal').then(m => m.VSTournamentModalLoader),
	{ ssr: false }
);

const RewardAnnouncementModalLoader = dynamic(
	() => import('./reward-announcement-modal').then(m => m.RewardAnnouncementModalLoader),
	{ ssr: false }
);

const LogoutMessageModal = dynamic(
	() => import('./jupiter').then(m => m.LogoutMessageModal),
	{ ssr: false }
);

export const SiteModals = () => {
	const isOddsListPage = useIsOddsListPage();

	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;

	return (
		<>
			{isAthena ? <AthenaModals /> : null}

			{/* ApiSite 沒有 AthenaModals，但 use-account-error.ts 的 107 alertAndSignOut
			    (以及其他呼叫 openJupiterLogoutMessageModal 的地方) 兩邊都要用，
			    所以獨立拉出來兩邊都會 mount。*/}
			<LogoutMessageModal />

			<LoginModalLoader />
			<MessageModalLoader />
			<SportEditModalLoader />
			<NickNameModalLoader />
			<ExchangeModalLoader />
			<FeatureUpdatedModalLoader />
			{isOddsListPage ? <RevisionTutorialModalLoader /> : null}
			<VSTournamentModalLoader />
			<RewardAnnouncementModalLoader />
		</>
	);
};